import { configServiceModule } from '../config-service/config-service';
import { appConfig } from '../../constants/app-config';
import { productMessageBannerComponentModule } from '../../components/product-message-banner/product-message-banner';

/**
 * Configures a service that tracks the release version through sockets and API-based config.
 * If the app release differs from the current release, we show a banner
 */
export const releaseAlertServiceModule = angular
  .module('Q.services.release-alert-service', [
    configServiceModule,
    productMessageBannerComponentModule,
  ])
  .factory(
    'releaseAlertService',
    function (
      configService,
      productMessageBannerService,
      $http,
      $window,
      $timeout,
      $log,
    ) {
      // TODO: provide hooks into this service as to when it's OK
      //   to just automatically reload.
      // Thoughts:
      // - Listen to state change events and clearing a flag if the URL changes
      //   - Individual states can alert they are safe to reload (i.e., simple lists)
      // - Use idle service to recognize if the page is idle, and only reload then
      // - Maybe look at automatically detecting $dirty input fields or forms (maybe hook
      //   into <form> component)?
      //
      // We don't release so often this is necessary, but sometimes we release multiple times
      //   in a row, which might be annoying. Automatically handling it means we could avoid
      //   annoying users.

      let alertTimeout;
      let loaded;
      const forceReload = () => {
        $http
          .get($window.location.href, {
            headers: {
              Pragma: 'no-cache',
              Expires: -1,
              'Cache-Control': 'no-cache',
            },
          })
          .finally(() => {
            $window.location.reload(true);
          });
      };

      const cancelTimeout = () => {
        $timeout.cancel(alertTimeout);
        alertTimeout = null;
      };

      const showAlert = (newRelease) => {
        cancelTimeout();

        $log.info(
          `New Qualified deployment detected. Old "${appConfig.release}" -> New "${newRelease}"`,
        );

        // Delay banner for a bit to ensure the deploy isn't rolled back or something similar.
        // this gives us a 4+ minute buffer to rollback changes, or to ensure that the
        // deploy has fully rolled out to everything.
        // There's some randomness hiding in here, too, so we can stagger users reloading the
        // page right after a rollout.
        alertTimeout = $timeout(
          () => {
            productMessageBannerService.showSuccess(
              'A new version of Qualified is available!',
              {
                linkTitle: 'When you are ready, click here to activate!',
                linkAction: forceReload,
                icon: 'product-changes-sm',
              },
            );
          },
          (4 + Math.random() * 4) * 60 * 1000,
        );
      };
      const svc = {
        listen(sockets) {
          if (!appConfig.release || !$window.Modernizr || loaded) {
            $log.debug('Skipping listening for release updates');
            return;
          }

          loaded = true;

          configService
            .load()
            .then((config) => {
              if (config.release && config.release !== appConfig.release) {
                showAlert(config.release);
              }

              svc.channel = sockets.listen('release', 'release');

              svc.channel.subscribe('deployed', (data) => {
                const { release, env } = data.data || {};
                cancelTimeout();

                if (
                  $window.Modernizr[`qualified-${env}`] &&
                  release !== appConfig.release
                ) {
                  showAlert(release);
                }
              });
            })
            .catch(() => {});
        },
      };

      return svc;
    },
  );
